module.exports = __webpack_public_path__ + "static/media/gl.1495643c.svg";